
const goToForm = () => {
        window.location.href ="https://forms.gle/ybJcQDrcQaXZfo5t6";
};
export default goToForm;
